import { matchPath } from 'react-router-dom';
import { hasKeycloakAuthority } from '../../app/roles';

const title = (text) => text.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());

// Read the actual Route/PrivateRoute declarations, so favourites cannot drift from route gates.
export const pageMetadata = (pathname, routes, keycloak, can) => {
  const path = pathname === '/' ? '/home' : pathname.replace(/\/$/, '');
  for (const route of routes) {
    const match = matchPath({ path: route.props.path, end: true }, path);
    if (!match) continue;
    const gate = route.props.element.props;
    if (gate.requiredAuthority && !hasKeycloakAuthority(keycloak, gate.requiredAuthority)) return null;
    if ([gate.requiredPermission, ...(gate.requiredPermissions || [])].filter(Boolean).some((key) => !can(key))) return null;
    if (gate.requiredAnyPermissions?.length && !gate.requiredAnyPermissions.some(can)) return null;
    const segments = route.props.path.split('/').filter(Boolean);
    const label = segments.map((segment) => segment.startsWith(':') ? match.params[segment.slice(1)] : title(segment)).join(' / ');
    return { path, label: label.slice(0, 200) };
  }
  return null;
};

// Hidden favourites retain their slots while the visible entries change order.
export const mergeVisibleOrder = (items, visible) => {
  const ids = new Set(visible.map((item) => item.id));
  let index = 0;
  return items.map((item) => ids.has(item.id) ? visible[index++].id : item.id);
};
